import { Component, ElementRef, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { PeriodicElement } from '../shared';
import { SelectionModel } from '@angular/cdk/collections';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ReportsService } from './reports.service';
import { EditReportComponent } from './edit-report/edit-report.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../shared/services/shared.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, AuthError, InteractionStatus } from '@azure/msal-browser';
import { service, factories } from 'powerbi-client';
import { ReplaySubject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { SharedAuthService } from '../shared/shared.auth.service';
import { AddNewReportComponent } from './add-new-report/add-new-report.component';
import { DailogModalComponent } from '../shared/elements/dailog-modal/dailog-modal.component';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css'],
  standalone: false
})
export class ReportsComponent implements OnInit {
  @ViewChild('panel1') firstPanel: MatExpansionPanel;
  @ViewChild(AddNewReportComponent) addNewReportComponent?: AddNewReportComponent;
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  selection = new SelectionModel<PeriodicElement>(true, []);
  reports: Array<any> = [];
  reportsByCategory: Array<any> = [];
  dataLoad: boolean = false;
  reportFormat: any = 'card';
  reportData: any;
  datarefresh: boolean;
  env = environment.environmentName;
  selectedReport: any;
  reportNameFromQueryParam = false;
  HTML: any;
  report: any;
  secureGrpRestriction: any = [];
  reportName: any;
  public pageSizes = [10, 20, 30];
  powerbi = new service.Service(factories.hpmFactory, factories.wpmpFactory, factories.routerFactory);
  state: any;
  reportContainer: any;
  context: any;
  accessToken: any;
  embedUrl: any;
  selectedSecure: any = [];
  MSDLCOMPLETED: any = false;
  private _destroying$: ReplaySubject<boolean> = new ReplaySubject(1);
  isExtractView: boolean = false;
  extractReportType: string = 'Large Extracts';
  treeData: any = [];
  displayedExtractColumns = ['fileName', 'Action'];
  tabs: Array<any> = [ { label: 'Cards', value: 'card' },
    { label: 'List', value: 'table' }];
  @ViewChild(MatPaginator) extractPaginator: MatPaginator;
  extractCol = [
    {
      columnDef: 'fileName',
      header: 'File Name',
      width: '80%',
      textAlign: 'left',
      sort: true,
      cell: (element: any) => `${element.fileName}`
    },
    {
      columnDef: 'url',
      header: 'Action',
      width: '20%',
      textAlign: 'center',
      type: 'extract-action',
      cell: () => ``
    }
  ];
  reportTypes: Array<string> = [];
  reportCategoryList: Array<string> = [];
  hasReportAdminAccess: boolean = false;
  constructor(
    private reportsService: ReportsService,
    public dialog: MatDialog,
    public toaster: ToastrService,
    private router: Router,
    private acRouter: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private msalService: MsalService, 
    private broadcastService: MsalBroadcastService,
    private sharedAuthService: SharedAuthService
  ) {
    this.MSDLCOMPLETED = false;
    this.msalService.initialize();
    this.reportFormat = 'card';
    this.acRouter.queryParams.subscribe((reportData: any) => {
      this.getAllReports();
      this.initialiseLargeExtracts(); //for initialising the large extracts
      if (reportData['Report']) {
        this.reportNameFromQueryParam = true;
        this.reportName = reportData['Report'];
        if (this.reportName) this.findReportNameFromURL(this.reportName);
      } else {
        this.reportNameFromQueryParam = false;
      }
    });
  }

  async ngOnInit() {
    // User input - null check
    if (environment.workspaceId === '' || environment.reportId === '') {
      console.log('Please assign values to workspace Id and report Id in Config.ts file');
      return;
    }

    this.authenticate();
    
    const groups = JSON.parse(sessionStorage.getItem('secureGroups'));
    this.selectedSecure = Object.keys(groups).filter(item => groups[item] === 'Yes');
    this.hasReportAdminAccess = this.sharedAuthService.getTohPageAccessDetails('Reports','Report_admin','edit');
  }
  getAllReports() {
    this.reportsService.getReports({ Page_name: 'Reports' }).subscribe(result => {
      if (result.length > 0) {
        this.reports = result;
        result.sort((a, b) => a['Category_rank'] - b['Category_rank']);
        const groupByCategory = result.groupBy(report => {
          return report.Category;
        });
        this.reportsByCategory = Object.keys(groupByCategory).map(function(reportIndex) {
          const category = groupByCategory[reportIndex];
          return category;
        });
        this.reportsByCategory.forEach(element => {
          element.sort((a, b) => {
            const reportA = a.Report.toLowerCase(),
              reportB = b.Report.toLowerCase();

            if (reportA < reportB) {
              return -1;
            }
            if (reportA > reportB) {
              return 1;
            }
            return 0;
          });
        });
        this.reports.sort((a, b) => {
          const reportA = a.Report.toLowerCase(),
            reportB = b.Report.toLowerCase();

          if (reportA < reportB) {
            return -1;
          }
          if (reportA > reportB) {
            return 1;
          }
          return 0;
        });
        this.dataSource = new MatTableDataSource(this.reports);
        this.selection = new SelectionModel<PeriodicElement>(true, []);
        this.dataSource.paginator = this.paginator;
        this.dataLoad = true;
        this.dataSource.filterPredicate = function(record, filter) {
          return record.Report.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) !== -1;
        };
        this.dataLoad = true;
        
        this.reportTypes = Array.from(new Set(this.reports.map(report => report.Report_Type)));
        this.reportCategoryList = Array.from(new Set(this.reports.map(report => report.Category)));
        if (this.reportName) this.findReportNameFromURL(this.reportName);
      } else {
        this.dataLoad = false;
      }
    });
  }

  onDatarefresh(eve) {
    if (eve == true) {
      this.getAllReports();
      this.reportFormat = 'table';
    }
  }

  callReportAPI(ev){
    if(ev){
      this.getAllReports();
    }
  }

  displayedColumns = [
    {
      columnDef: 'report',
      header: 'Report',
      width: '38%',
      textAlign: 'left',
      type: 'reportTitle',
      cellStyle: () => {
        return {
          'center-text': `More Details`
        };
      },
      cell: (element: any) => `${element.Report}`
    },
    {
      columnDef: 'Category',
      header: 'Report Category',
      width: '20%',
      textAlign: 'left',
      type: 'Category',
      cellStyle: () => {
        return {
          'center-text': `More Details`
        };
      },
      cell: (element: any) => `${element.Category}`
    },
    {
      columnDef: 'description',
      header: 'Description',
      type: 'DescriptionReport',
      width: '20%',
      textAlign: 'left',
      cellStyle: () => {
        return {
          'center-text': `More Details`,
          'font-size': '0.9vw'
        };
      },
      cell: (element: any) => `${element.Description}`
    },
    {
      columnDef: 'type',
      header: 'Type',
      width: '12%',
      textAlign: 'left',
      type: 'TypeReport',
      cellStyle: () => {
        return {
          'center-text': `More Details`
        };
      },
      cell: (element: any) => `${element.Report_Type}`
    },
    {
      columnDef: 'action',
      header: 'Actions',
      width: '20%',
      textAlign: 'center',
      type: 'action',
      cellStyle: () => {
        return {
          'center-text': `More Details`
        };
      },
      cell: () => ` `,
      reportLink: (element: any) => `${element.Report_Link}`,
      access: (element: any) => `${element.Access_Restricted}`,
      secure_group: (element: any) => `${element.Secure_group}`,
      documentation: (element: any) => `${element.Documentation}`,
      ownerDetails: (element: any) => `${element.ownerDetails}`,
      HasOwner: (element: any) => `${element.HasOwner}`,
      id: (element: any) => `${element.id}`,
      reportName: (element: any) => `${element.Report}`,
      reprtDescription: (element: any) => `${element.Description}`
    }
  ];

  reportFormatChange(e) {
     this.reportFormat = this.tabs[e.index].value;
  }

  findReportNameFromURL(reportName: any) {
    let filteredReport;
    const fetchedReportNameFrmURL = reportName;
    filteredReport = this.reports.filter(reportItem => reportItem.Report === fetchedReportNameFrmURL);
    if (filteredReport[0].Access_Restricted === 'Yes' && filteredReport[0]['Secure'] === 'Yes') {
      let reportSecure = filteredReport[0]['Secure_Check'].split(',');
      reportSecure = reportSecure.filter((item: any) => this.selectedSecure.includes(item));
      this.secureGrpRestriction = reportSecure;
      if (reportSecure.length > 0) {
        if (filteredReport[0].EMbed == 'Yes') {
          this.openEmbededReport(reportName);
        } else if (filteredReport[0].Report_Type == this.extractReportType) {
          this.isExtractView = true;
          this.getExtractReport(filteredReport[0].Report_Link);
        } else {
          window.open(filteredReport[0].Report_Link, '_blank');
        }
      } else {
        window.open(filteredReport[0].Access_Restriction_link, '_blank');
        this.router.navigateByUrl('/reports');
      }
    } else {
      window.open(filteredReport[0].Report_Link, '_blank');
    }
  }

  private isInternalReportType(report: any): boolean {
    const type = report?.Report_Type;
    return type === 'Power BI' || type === 'inBuilt' || type === this.extractReportType;
  }

  private isSecureRestricted(report: any): boolean {
    return report?.Access_Restricted === 'Yes' && report?.['Secure'] === 'Yes';
  }

  private getMatchedSecureGroups(report: any): any[] {
    const raw = report?.['Secure_Check'];
    if (!raw) return [];
    const list = raw.split(',');
    return list.filter((item: any) => this.selectedSecure.includes(item));
  }

  private openAccessHelpLinks(report: any): void {
    if (report?.Access_Restriction_link) window.open(report.Access_Restriction_link, '_blank');
    else if (report?.Documentation) window.open(report.Documentation, '_blank');
  }

  private navigateToReportsQuery(report: any): void {
    this.router.navigateByUrl('reports?Report=' + report.Report);
  }

  private navigateToInbuiltReport(report: any): void {
    try {
      const reportName = report?.Report;
      if (!reportName) {
        console.error('navigateToInbuiltReport: missing Report name', report);
        this.toaster.error('Unable to navigate to inbuilt report', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        return;
      }

      const navResult: any = this.router.navigateByUrl('reports/inbuilt-report?ReportName=' + reportName);
      // navigateByUrl returns a Promise<boolean> in most Angular versions; catch async failures too.
      if (navResult && typeof navResult.catch === 'function') {
        navResult.catch((err: any) => {
          console.error('Navigation to inbuilt report failed', err);
          this.toaster.error('Unable to navigate to inbuilt report', '', { timeOut: 5000, positionClass: 'toast-top-center' });
        });
      }
    } catch (err) {
      console.error('Unexpected error navigating to inbuilt report', err);
      this.toaster.error('Unable to navigate to inbuilt report', '', { timeOut: 5000, positionClass: 'toast-top-center' });
    }
  }

  private navigateRestrictedReport(report: any): boolean {
    if (report?.Embed_type === 'Web') {
      if (report?.Report_Type === 'inBuilt') {
        this.navigateToInbuiltReport(report);
      }else if (report?.Report_Type === 'Power BI') {
        this.router.navigateByUrl(
          'reports/powerbi-report?ReportName=' + report.Report + '&ReportID=' + report.Report_Id
        );
      } else {
        this.navigateToReportsQuery(report);
      }
      return true;
    }

    if (report?.Embed_type === 'No') {
      if (report?.Report_Type === 'inBuilt') {
        this.navigateToInbuiltReport(report);
      } else {
        this.navigateToReportsQuery(report);
      }
      return true;
    }

    if (report?.Embed_type === 'Iframe') {
      return this.renderIframeReport(report);
    }

    return false;
  }

  private renderIframeReport(report: any): boolean {
    const iframeSrc = this.repairEmbedIframeSrc(report?.Embed_link);
    const reportId = report?.Report_Id || this.extractReportIdFromIframeSrc(iframeSrc);
    const reportName = report?.Report || '';

    if (!iframeSrc) {
      this.toaster.error('Unable to route embedded report to Power BI page', '', { timeOut: 5000, positionClass: 'toast-top-center' });
      return false;
    }

    this.router.navigateByUrl(
      'reports/powerbi-report?ReportName=' + encodeURIComponent(reportName)
      + '&ReportID=' + encodeURIComponent(reportId || '')
      + '&EmbedUrl=' + encodeURIComponent(iframeSrc)
    );
    return true;
  }

  private extractReportIdFromIframeSrc(iframeSrc: string): string {
    if (!iframeSrc) {
      return '';
    }

    try {
      const parsedUrl = new URL(iframeSrc);
      return parsedUrl.searchParams.get('reportId') || parsedUrl.searchParams.get('reportID') || '';
    } catch {
      return '';
    }
  }

  private repairEmbedIframeSrc(embedLink: string): string {
    if (!embedLink || typeof embedLink !== 'string') {
      return '';
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(embedLink, 'text/html');
    const iframe = doc.querySelector('iframe');
    let src = iframe?.getAttribute('src') || '';

    if (src.includes('%22')) {
      src = src.split('%22')[0];
    }
    if (src.includes(' frameborder=')) {
      src = src.split(' frameborder=')[0];
    }

    src = (src || '').trim();
    if (!src) {
      return '';
    }

    return src;
  }

  navigateUrl(Report: any) {
    this.selectedReport = Report;
    if (!this.isInternalReportType(Report)) {
      window.open(Report.Report_Link, '_blank');
      return;
    }

    if (!this.isSecureRestricted(Report)) {
      const navigated = this.navigateRestrictedReport(Report);
      if (!navigated && Report.Report_Type && Report.Report_Type.toLowerCase() == 'inbuilt') {
        this.navigateToInbuiltReport(Report);
      } else if (!navigated && Report?.Report_Link) {
        window.open(Report.Report_Link, '_blank');
      }
      return;
    }
    if(this.hasReportAdminAccess) {
      const navigated = this.navigateRestrictedReport(Report);
      if(navigated) {
        return;
      }else if (!navigated && Report.Report_Type && Report.Report_Type.toLowerCase() == 'inbuilt') {
        this.navigateToInbuiltReport(Report);
        return;
      } 
    }

    const reportSecure = this.getMatchedSecureGroups(Report);
    this.secureGrpRestriction = reportSecure;
    if (reportSecure.length === 0) {
      this.openAccessHelpLinks(Report);
      return;
    }

    const navigated = this.navigateRestrictedReport(Report);
    if (!navigated) {
      this.openAccessHelpLinks(Report);
    }
  }
  copyToClipboard(report) {
    let report_URL = '';
    if (report.Report_Link && report.Report_Link.trim() !== '') {
      report_URL = report.Report_Link;
    } else {
      report_URL = window.location.origin + '/reports/powerbi-report?ReportName=' + report.Report;
      if (!report_URL) {
        report_URL = this.getReportLinkFromEmbedLink(report); // fallback to get the report link for Power BI
      }
    }
    document.addEventListener('copy', (e: ClipboardEvent) => {
      e.clipboardData.setData('text/plain', report_URL);
      e.preventDefault();
      document.removeEventListener('copy', null);
    });
    document.execCommand('copy');
  }

  //Function to get the report link from the embed link
  getReportLinkFromEmbedLink(report: any): string {
    if (report.Embed_link) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(report.Embed_link, 'text/html');
      const iframe = doc.querySelector('iframe');
      if (iframe?.hasAttribute('src')) {
        const src = iframe.getAttribute('src');
        return this.sanitizer.sanitize(SecurityContext.URL, src) || '';
      }
    }
    return '';
  }

  showToolTip(secure_group: any) {
    return 'Request Access to ' + secure_group + ' to view Report';
  }
  showDocumentionInfo(docuMentUrl: any) {
    window.open(docuMentUrl, '_blank');
  }

  editReport(report: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      id: report.id,
      Report: report.Report,
      Description: report.Description,
      Report_Link: report.Report_Link
    };
    dialogConfig.width = '50%';
    dialogConfig.hasBackdrop = false;
    dialogConfig.panelClass = 'custom-modalbox';
    dialogConfig.height = '62%';
    dialogConfig.disableClose = false;
    dialogConfig.maxWidth = '80vw';
    dialogConfig.position = { right: '340px', top: '140px' };

    const dialogRef = this.dialog.open(EditReportComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result.anyChangeInData) {
        this.getAllReports();
      }
    });
  }

  /** Opens the full Add/Edit Report popup (Template + Json-Editor) pre-filled with this report. */
  openFullReportEditor(report: any): void {
    this.addNewReportComponent?.editReport(report);
  }

  deleteTohReport(report: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.hasBackdrop = true;
    dialogConfig.minHeight = '200px';
    dialogConfig.height = 'auto';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'Delete Confirmation!',
      subTitle: 'Are you sure you want to delete this report? This action cannot be undone.',
      buttonName: 'Continue'
    };
    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data !== 'cancel') {
        this.reportsService.deleteTOHReport(report?.id).subscribe({
          next: (_: any) => {
            this.toaster.success(`${report?.Report || 'Report'} has been deleted successfully`, '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
            this.getAllReports();
          },
          error: (_: any) => {
            this.toaster.error('Error deleting report', '', {
              timeOut: 3000,
              positionClass: 'toast-top-center'
            });
          }
        });
      }
    });
  }
  reportHasLoggedInUserOwner(report: any) {
    const loggedInUserMSID = this.sharedAuthService.getMsid();
    if (report.ownerDetails != null) {
      const owners = report.ownerDetails.split(',').map(x => x.trim());
      const reportOwnerIsloggedinUser = owners.includes(loggedInUserMSID);
      if (reportOwnerIsloggedinUser && report.HasOwner == 'Yes') {
        return true;
      } else return false;
    } else return false;
  }

  searchDataSet(event) {
    const filterValue = event ? (event.target as HTMLInputElement).value : '';
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.reports = this.dataSource.filteredData;
    const groupByCategory = this.dataSource.filteredData.reduce((group, report) => {
      const { Category } = report;
      group[Category] = group[Category] ?? [];
      group[Category].push(report);
      return group;
    }, {});
    this.reportsByCategory = Object.keys(groupByCategory).map(function(reportIndex) {
      const category = groupByCategory[reportIndex];
      return category;
    });
  }
  info() {
    window.open(environment.docUrl + 'user-guide/reports-data-extract/');
  }

  openEmbededReport(name) {
    this.reportsService.getReport(name).subscribe(result => {
      if (result.length > 0) {
        this.report = result[0];
        this.HTML = this.sanitizer.bypassSecurityTrustHtml(this.report.Embed_link);
      }
    });
  }

  // Authenticating to get the access token
  authenticate(): void {
    const msalInstance = this.msalService.instance;
    const msalAccounts = msalInstance.getAllAccounts();
    const msalInProgress = this.broadcastService.inProgress$;
    const isAuthenticated = msalInstance.getAllAccounts().length > 0;

    const eventCallback = msalInstance.addEventCallback((message: EventMessage) => {
      if (message.eventType === EventType.LOGIN_SUCCESS && !this.accessToken) {
        const payload = message.payload as AuthenticationResult;
        const name: string = payload.account?.name ? payload.account?.name : '';

        this.accessToken = payload.accessToken;
        sessionStorage.setItem('ptoken', this.accessToken);
        this.setUsername(name);
        this.tryRefreshUserPermissions();
      }
    });

    const loginRequest = {
      scopes: environment.scopeBase,
      account: msalAccounts[0]
    };
    // handle auth redired/do all initial setup for msal
    msalInstance
      .handleRedirectPromise()
      .then(() => {
        // Check if user signed in
        const account = msalInstance.getAllAccounts();
        if (!account) {
          // redirect anonymous user to login page
          msalInstance.loginRedirect(loginRequest);
        }
      })
      .catch(err => {
        // TODO: Handle errors
        console.log(err);
      });
    msalInProgress
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(async () => {
        if (!isAuthenticated) {
          await msalInstance.loginRedirect(loginRequest);
        } else if (isAuthenticated && this.accessToken) {
          msalInstance.removeEventCallback(eventCallback);
        } else if (isAuthenticated && !this.accessToken) {
          this.setUsername(msalAccounts[0].name);

          // get access token silently from cached id-token
          msalInstance
            .acquireTokenSilent(loginRequest)
            .then((response: AuthenticationResult) => {
              this.accessToken = response.accessToken;
              sessionStorage.setItem('ptoken', this.accessToken);
              this.MSDLCOMPLETED = true;
            })
            .catch((error: AuthError) => {
              // Refresh access token silently from cached id-token
              // Makes the call to handleredirectcallback
              if (
                error.errorCode === 'consent_required' ||
                error.errorCode === 'interaction_required' ||
                error.errorCode === 'login_required'
              ) {
                msalInstance.acquireTokenRedirect(loginRequest);
              } else if (error.errorCode === '429') {
                console.log('Our Service Token Server (STS) is overloaded, please try again in sometime');
              } else {
                console.log('There was some problem fetching the access token' + error.toString());
              }
            });
        }
      });
  }
  // Power BI REST API call to refresh User Permissions in Power BI
  // Refreshes user permissions and makes sure the user permissions are fully updated
  // https://docs.microsoft.com/rest/api/power-bi/users/refreshuserpermissions
  tryRefreshUserPermissions(): void {
    fetch(environment.powerBiApiUrl + 'v1.0/myorg/RefreshUserPermissions', {
      headers: {
        Authorization: 'Bearer ' + this.accessToken
      },
      method: 'POST'
    })
      .then(function(response) {
        if (response.ok) {
          console.log('User permissions refreshed successfully.');
        } else {
          // Too many requests in one hour will cause the API to fail
          if (response.status === 429) {
            console.error('Permissions refresh will be available in up to an hour.');
          } else {
            console.error(response);
          }
        }
      })
      .catch(function(error) {
        console.error('Failure in making API call.' + error);
      });
  }

  // Show username in the UI
  setUsername(username: string): void {
    const welcome = document.getElementById('welcome');
    if (welcome !== null) welcome.innerText = 'Welcome, ' + username;
  }

  // Get the extract report data
  getExtractReport(extractReportURL) {
    this.reportsService.getExtractReport(extractReportURL).subscribe(
      result => {
        if (result) this.convertResponseIntoTree(result);
      },
      error => {
        this.handleErrors(error);
      }
    );
  }

  handleErrors(error: any) {
    console.error('An error occurred:', error);
    this.toaster.error('Error while fetching data', '', {
      timeOut: 5000,
      positionClass: 'toast-top-center'
    });
  }

  //converting the data from API response into tree structure
  convertResponseIntoTree(response) {
    this.treeData = Object.keys(response).map(key => this.createTreeNode(key, response[key]));
  }

  //creating the tree node
  createTreeNode(key, subTree) {
    const children = Object.keys(subTree).map(subKey => this.createSubTreeNode(subKey, subTree[subKey]));
    return { name: key, children, expanded: false };
  }

  //creating the sub tree node
  createSubTreeNode(subKey, elements) {
    const subChildren = elements.map((element, index) => ({
      id: element.id,
      fileName: element.fileName,
      url: element.url,
      position: index
    }));
    return { name: subKey, children: subChildren, expanded: false, source: new MatTableDataSource(subChildren) };
  }

  //for toggling the node of tree structure
  toggleNode(node) {
    node.expanded = !node.expanded;
  }

  //for initialising the large extracts initial value
  initialiseLargeExtracts() {
    this.isExtractView = false;
    this.treeData = [];
  }

  //back to reports url to list all reports available
  backToReports() {
    this.isExtractView = false;
    this.treeData = [];
    this.reportNameFromQueryParam = false;
    this.router.navigateByUrl('/reports');
  }
}
